(() => {
  const initialHash = document.documentElement.dataset.categoryInitialHash || location.hash;
  delete document.documentElement.dataset.categoryInitialHash;
  const legacyCategories = {
    featured_collections_R9jn9p: 'body-care',
    featured_collections_6WrWxr: 'body-care',
    featured_collections_iGRgG4: 'body-cleansers',
    featured_collections_F4UgYL: 'body-cleansers',
    featured_collections_yDDpjD: 'hands',
    featured_collections_CfVcjL: 'hands',
    featured_collections_n8FcWr: 'giftboxes',
    featured_collections_4T6c3z: 'giftboxes',
    featured_collections_UfTJdm: 'travel-sizes',
    featured_collections_fwLcb3: 'travel-sizes',
    featured_collections_bCHPFi: 'accessories',
    featured_collections_M9ecTJ: 'accessories'
  };
  let stopNavigation = null;
  let activeHash = initialHash;

  function fragment(hash) {
    try {
      return decodeURIComponent(hash.replace(/^#/, ''));
    } catch (_) {
      return hash.replace(/^#/, '');
    }
  }

  function resolve(hash) {
    const raw = fragment(hash || '');
    const legacy = raw.match(/^shopify-section-template--\d+__([\w-]+)$/);
    const category = legacy ? legacyCategories[legacy[1]] : null;
    const stable = category ? `category-${category}` : raw;
    if (stable.startsWith('category-') && /^[\w-]+$/.test(stable)) {
      return {
        hash: `#${stable}`,
        target: document.getElementById(stable)
      };
    }
    if (!legacy) return null;
    const section = document.getElementById(raw) || document.querySelector(`[id$="__${legacy[1]}"]`);
    return section ? {
      hash,
      target: section.querySelector('h1, h2, h3, h4, h5, h6') || section
    } : null;
  }

  function align(target) {
    const stickyHeight = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const top = Math.max(0, Math.round(target.getBoundingClientRect().top + window.scrollY - stickyHeight - 16));
    if (Math.abs(window.scrollY - top) > 1) {
      window.scrollTo({ top, behavior: 'instant' });
    }
  }

  function navigate(hash, focus = false) {
    stopNavigation?.();
    activeHash = hash;
    const started = Date.now();
    let focused = false;
    let timer;
    let frame;
    let observer;
    const stop = () => {
      clearInterval(timer);
      cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchmove', stop);
      window.removeEventListener('pointerdown', stop);
      window.removeEventListener('keydown', stop);
      if (stopNavigation === stop) stopNavigation = null;
    };
    const check = () => {
      if (Date.now() - started > 10000) {
        stop();
        return;
      }
      const resolved = resolve(hash);
      if (!resolved?.target) return;
      if (focus && !focused) {
        resolved.target.focus({ preventScroll: true });
        focused = true;
      }
      align(resolved.target);
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(check);
    };
    stopNavigation = stop;
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchmove', stop, { passive: true });
    window.addEventListener('pointerdown', stop, { passive: true });
    window.addEventListener('keydown', stop);
    observer = new MutationObserver(schedule);
    observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    timer = setInterval(check, 120);
    check();
    return () => {
      if (stopNavigation !== stop) return;
      focus = true;
      check();
    };
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href*="#"]');
    if (!link || link.hasAttribute('download') || link.target && link.target !== '_self') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search && url.search !== location.search) return;
    const resolved = resolve(url.hash);
    if (!resolved?.target) return;
    event.preventDefault();
    const next = new URL(location.href);
    next.hash = resolved.hash;
    if (next.hash !== location.hash) history.pushState(history.state, '', next.toString());
    const drawer = link.closest('header-sidebar[open]');
    const disclosure = link.closest('details[open]');
    if (disclosure) disclosure.open = false;
    const completeNavigation = navigate(resolved.hash, !drawer);
    if (drawer && typeof drawer.hide === 'function') {
      Promise.resolve(drawer.hide()).then(() => {
        setTimeout(() => {
          if (location.hash === resolved.hash && !drawer.open) completeNavigation();
        }, 0);
      });
    }
  }, true);

  const followLocation = () => {
    activeHash = location.hash;
    if (resolve(location.hash)) navigate(location.hash);
    else stopNavigation?.();
  };
  window.addEventListener('hashchange', followLocation);
  window.addEventListener('popstate', followLocation);
  const followPage = () => {
    const hash = location.hash || activeHash;
    if (resolve(hash)) navigate(hash);
  };
  window.addEventListener('pageshow', followPage);
  document.addEventListener('shopify:section:load', followPage);
  if (resolve(initialHash)) navigate(initialHash);
})();
